<template>
    <app-dialog :title="$t('totalsByLab.title')" subtitle="" v-bind="$attrs" @input="onCloseDialog">
        <template v-slot:content>
            <!--<v-progress-circular v-if="!privacyPolicy" indeterminate></v-progress-circular>

            <p v-else class="font-size-md mx-1 description-text" v-html="privacyPolicy"></p>-->
            <v-row>
                 <!--<v-progress-circularv-if= v-if="!showCamera" indeterminate></v-progress-circularv-if="showListEan">-->
                <v-col cols="12" class="full-height ml-height wrapper-list-ean">
                <v-simple-table ref="tablelistean">
                    <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                {{ tb('LABORATÓRIO') }}
                            </th>
                            <th class="text-left">
                                {{ tb('SUBTOTAL') }}
                            </th>
                            <th class="text-left">
                                {{ tb('TOTAL IVA') }}
                            </th>
                            <th class="text-left">
                                {{ tb('TOTAL') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                        v-for="(item,index) in currentData"
                        :key="item.laboratory"
                        >
                        <td>{{ item.laboratory }}</td>
                        <td class="text-left" style="padding-left: 0;">{{ formatPrice(item.subtotal) }}</td>
                        <td class="text-left" style="padding-left: 0;">{{ formatPrice(item.tax) }}</td>
                        <td class="text-left" style="padding-left: 0;"><b>{{ formatPrice(item.total)}}</b></td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
                </v-col>
            </v-row>
        </template>

        <template v-slot:buttons="{}">
            <!--<v-btn text class="myprovet-btn-btn-cancel" @click="onCloseDialog" data-cy="app-dialog-confirm-btn">Fechar</v-btn>-->
        </template>
    </app-dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useNormalOrderStore } from '@/Stores/normalorder';
export default {
    data() {
        return {
            showCamera:false,
        };
    },
    computed:{
        ...mapStores(useNormalOrderStore),
       currentData(){
           return _.orderBy(this.normalOrderStore.getListTotalByLabs,['laboratory'],['asc'])
       }
    },
    created() {
    },
    methods: {
        onCloseDialog() {
            this.normalOrderStore.setListTotalByLabs(null)
            this.$emit('onCancel', false);
        },
        onDialogInput(event) {
            if (!event) {
                this.$emit('onCancel', false);
            }
        },
    },
};
</script>
